module.exports = __webpack_public_path__ + "static/media/photo16.d1afe909.jpg";